import React, { useEffect } from 'react'

// components
import CarDropdown from '../components/CarDropdown'
import FilterTable from '../components/FilterTable'
import FavouriteButton from '../components/FavouriteButton'
import { ButtonToolbar, Container, Header, Content } from 'rsuite';
import TimeChart from '../components/TimeChart';
import WeatherForecast from '../components/WeatherForecast'

// redux
import { useSelector, useDispatch } from 'react-redux'
import { getContextOptions, getOptions, getYou, getDisplayOptions, getShowWeather } from '../redux/options/selectors'  
import { getAllCars, getFastestPerCar } from '../redux/data/selectors'
import { setOption } from '../redux/options/actions'

import { ms2diff, laptime2ms } from '../tools/Time.js'
import { useParams, useNavigate } from 'react-router'
import CarLogo from '../components/CarLogo.jsx';

// Group page
const CarPage = ( { context = 'carpage' } ) => {

  // redux
  const dispatch = useDispatch()
  let { car = 0, group = '' } = getContextOptions( useSelector( getOptions ), context )
  const cars = useSelector( getAllCars )
  const fastest = useSelector( getFastestPerCar )
  const display = useSelector( getDisplayOptions )
  let you = useSelector( getYou )
  let { car: param } = useParams()
  const navigate = useNavigate()

  // make sure car and param are numbers
  param = param ? parseInt( param ) : 0
  car = car ? parseInt( car ) : 0
  you = you ? parseInt( you ) : 0

  // set car on startup if needed
  useEffect( () => {

    // reset group if needed
    if ( group )
    {      
      dispatch( setOption( 'group', '', context ) )
    }
    
    // nothing to choose from until laps are loaded
    if ( !cars.length ) return

    // change car by url param
    if ( param && param !== car && cars.includes( param ) )
    {
      dispatch( setOption( 'car', param, context ) )
    }
    // without a car of this contest, use your car, otherwise the first car
    else if ( !cars.includes( car ) )
    {
      dispatch( setOption( 'car', cars.includes( you ) ? you : cars[ 0 ], context ) )
    }

    // no url param but a you? go there
    if ( !param && you && cars.includes( parseInt( you ) ) )
    {
      navigate( '/car/' + you )
    }

  }, [ car, param, cars, you] )

  // set column options
  const column_options = {
    cat: false,
    id: false,
    lap: false,
    diff: true,
    pos: false
  } 

  // modify row data; add laptime improvement
  const modifyRows = ( rows ) => 
  {
    // check for a valid object
    if ( rows && rows.length )
    {
      // sort on creation date
      rows.sort( ( a, b ) => a.time > b.time ? 1 : -1 )
      // previous fastest time(stamp) in ms
      let fast_time = laptime2ms( rows[ 0 ].laptime )
      // calculate laptime improvement for each row
      rows.forEach( row => {
        // convert to miliseconds
        const time = laptime2ms( row.laptime )
        // get time difference
        row.diff = ms2diff( time - fast_time )
        row.faster = false
        // store faster time
        if ( time < fast_time ) 
        {
          row.faster = true
          fast_time = time
        }
      } )
    }
    // always return the rows
    return rows
  }

  // change url when dropdown changes
  const onChange = value => navigate( '/car/' + value )

  // add faster row class
  const rowClassName = ( row, className ) => {
    className += row.faster ? ' faster' : ''
    return className
  }

  let className = context
  if ( car === you ) className += ' your-car'
  
  const car_data = fastest.find( d => d.car === car ) || {}
  
  const summary_before = !car_data ? null :
    (
      <div className="model">
        <CarLogo brand={ car_data.model }/> 
        <span>{ car_data.model }</span>
      </div>
    )
    
  // the time graph with the weather forecast below it; without the graph the forecast takes its place
  const showWeather = useSelector( getShowWeather )
  const forecast = showWeather ? <WeatherForecast/> : null
  const chart = display.time_graph ? <TimeChart weather={ true }/> : forecast

  // render the car page
  return (
    <Container className={ className }>
      <Header>
        <ButtonToolbar className="filters">
          <CarDropdown showAll={ false } context={ context } onChange={ onChange }/>
          <FavouriteButton car={ car }/>
        </ButtonToolbar>
      </Header>
      <Content>     
        <FilterTable 
          summary_before={ summary_before }
          context={ context } 
          column_options={ column_options } 
          modifyRows={ modifyRows }
          rowClassName={ rowClassName }
          between={ chart }
          clickRow={ false }
        />
      </Content>
    </Container>
  )
}
export default CarPage